import { oz } from '@weft/utils';
import { InvoicesOverviewsSummarySchema } from './invoices-overviews-summary-schema';

export const GetInvoicesStatisticsResponseSchema = oz.object({
  summary: InvoicesOverviewsSummarySchema,
}).openapi('GetInvoicesStatisticsResponse');

export type GetInvoicesStatisticsResponse = oz.infer<typeof GetInvoicesStatisticsResponseSchema>;